import { Controller } from "stimulus"
import { submitForm } from "../helpers"

export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this)
  }

  disconnect() {
    this.element.removeEventListener("change", this)
  }

  handleEvent() {
    submitForm(this.element.form)
  }
}
